import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccaf11a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "super-centered" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logotipo mb-4",
    src: "https://i.imgur.com/Cb4nqcG.png",
    alt: "logo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Registo", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Criar a sua conta Goldylocks.", -1))
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "O seu email", -1))
const _hoisted_7 = { class: "control" }
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = { class: "field mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Senha", -1))
const _hoisted_11 = { class: "control" }
const _hoisted_12 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_13 = { class: "field mt-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Confirmação senha", -1))
const _hoisted_15 = { class: "control" }
const _hoisted_16 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "has-text-centered mt-2" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Regressar ao login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordForceCheck = _resolveComponent("PasswordForceCheck")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("form", {
        class: "box register-box",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
        autocomplete: "off"
      }, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", {'is-danger':_ctx.alreadyExistantEmail}]),
              type: "email",
              placeholder: "ex. cliente@exemplo.com",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              required: ""
            }, null, 2), [
              [_vModelText, _ctx.email]
            ])
          ]),
          (_ctx.alreadyExistantEmail)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Email já registado!"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", {'is-danger':_ctx.canCheckPasswords && !_ctx.enoughPasswordChars}]),
              type: "password",
              placeholder: "********",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              required: ""
            }, null, 2), [
              [_vModelText, _ctx.password]
            ])
          ]),
          (!_ctx.enoughPasswordChars && _ctx.passwordChars > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, "A senha tem de conter no minimo 8 carateres!"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_PasswordForceCheck, { password: _ctx.password }, null, 8, ["password"]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", {'is-danger':_ctx.canCheckPasswords && !_ctx.samePassword}]),
              type: "password",
              placeholder: "********",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordConfirmation) = $event)),
              required: ""
            }, null, 2), [
              [_vModelText, _ctx.passwordConfirmation]
            ])
          ]),
          (_ctx.canCheckPasswords && !_ctx.samePassword)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, "As senhas não coincidem!"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          disabled: !_ctx.enoughPasswordChars || !_ctx.samePassword,
          class: _normalizeClass(["button is-primary is-fullwidth mt-5", {'is-loading':_ctx.isLoading}])
        }, "Avançar", 10, _hoisted_17),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: "/login",
            class: "is-size-7 has-text-info"
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ], 32)
    ])
  ]))
}